import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import changeScreen from 'actions/router';

import constants from 'constants/constants';

import { HardwareButton } from 'components/buttons';

const NavButton = ({
  destination,
  position,
  navigateTo
}) => {
  const navigate = () => {
    const { rootRoute } = constants;

    navigateTo(`${rootRoute}/${destination}`);
  };

  return (
    <HardwareButton
      position={position}
      onClick={navigate}
    />
  );
};

NavButton.propTypes = {
  destination: PropTypes.string.isRequired,
  position: PropTypes.string.isRequired,
  navigateTo: PropTypes.func.isRequired
};

export default connect(null, {
  navigateTo: changeScreen
})(NavButton);



// WEBPACK FOOTER //
// ./src/components/buttons/NavButton/NavButton.js